import { Flex, useDisclosure, Popover, PopoverBody, PopoverTrigger, PopoverContent } from "@chakra-ui/react";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import { UseFormReturn, useController } from "react-hook-form";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { PlusCirlceButtonWithRef } from "components/Button/PlusCircleButton";
import { IconType } from "react-icons";
import UserSelectField from "components/FormElements/Fields/SelectFields/UserSelectField";
import RecipientTag from "components/Tag/ResourceTargetTag/RecipientTag";

interface UserFieldProps {
  form: UseFormReturn<any>;
  label: string;
  fieldName: string;
  roleFieldName: string;
  icon?: IconType;
  includeAdd?: boolean;
  disabled?: boolean;
}

export default function UserField({
  form,
  fieldName,
  roleFieldName,
  label,
  icon,
  disabled = false,
  includeAdd = true,
}: UserFieldProps) {
  const {
    control,
    formState: { errors },
  } = form;
  const { field } = useController({ control, name: fieldName });
  const { field: roleField } = useController({ control, name: roleFieldName });

  const { isOpen, onOpen, onClose, getDisclosureProps } = useDisclosure();
  const disclosureProps = getDisclosureProps();

  return (
    <HorizontalGreyBlackField icon={icon} label={label} labelContainerProps={longAttributeStyles.labelContainerProps}>
      <Popover matchWidth {...disclosureProps} onOpen={onOpen} onClose={onClose} isLazy>
        <Flex gap="1" align="center">
          {field.value && (
            <RecipientTag
              key={field.value}
              resourceId={field.value as unknown as string}
              resourceType="User"
              role={roleField.value}
              remove={() => form.setValue(fieldName, null, { shouldDirty: true })} // Remove the recipient
              disabled={disabled}
            />
          )}
          {includeAdd && !disabled && !field.value && (
            <PopoverTrigger>
              <PlusCirlceButtonWithRef label={`Add ${label}`} />
            </PopoverTrigger>
          )}
        </Flex>
        <PopoverContent
          pt="3"
          bg="var(--chakra-colors-chakra-body-bg)"
          width="100%"
          minWidth="250px"
          maxWidth="350px"
          display={isOpen ? "block" : "none"}
        >
          <PopoverBody>
            <UserSelectField
              name={fieldName}
              label={label}
              control={control}
              errors={errors}
              readOnly
              onChangeCallback={onClose}
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
              defaultMenuIsOpen
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </HorizontalGreyBlackField>
  );
}
